/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Document_Page_InvalidInputs */

const en_error_crm_document_page_invalid = /** @type {(inputs: Error_Crm_Document_Page_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A page of the PDF could not be used. Try the upload again.`)
};

/**
* | output |
* | --- |
* | "A page of the PDF could not be used. Try the upload again." |
*
* @param {Error_Crm_Document_Page_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_document_page_invalid = /** @type {((inputs?: Error_Crm_Document_Page_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Document_Page_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_document_page_invalid(inputs)
});